export const Project2: React.FC = () => {
    return (
        <div className="work-details  text-slate-800 dark:text-white">
            <div>project2</div>
            <div>project2</div>
            <div>project2</div>
            <div>project2</div>
            <div>project2</div>
            <div>project2</div>
            <div>project2</div>
            <div>project2</div>
            <div>project2</div>
            <div>project2</div>
            <div>project2</div>
            <div>project2</div>
            <div>project2</div>
            <div>project2</div>
            <div>project2</div>
            <div>project2</div>
            <div>project2</div>
            <div>project2</div>
            <div>project2</div>
            <div>project2</div>
            <div>project2</div>
            <div>project2</div>

        </div>
        );
};